export const SHOW_MORE_NUM = 5;
export const INITIAL_RESULT_SET_SIZE = 10;
export const PRIORITY_ORDER = ["recommend", "bestValue", "fastest"];
export const getPriorityIndex = (tag) => PRIORITY_ORDER.indexOf(tag.name);
